import React from 'react'
import './Header.scss'
import bbc from '../../img/logo-bbc.png'
import forbes from '../../img/logo-forbes.png'
import techcrunch from '../../img/logo-techcrunch.png'
import bi from '../../img/logo-bi.png'
export const Header = () => {
    return (
        <header className="header">
           
            <h3 className="heading-3">Ditt nya hem:</h3>
            <h1 className="heading-1">Ultimata personliga friheten</h1>
            <button className="btn header__btn">Se våra egendom</button>
            <div className="header__seenon-text">Sett på</div>
            <div className="header__seenon-logos">
                <img src={bbc} alt="Seen on logo 1"></img>
                <img src={forbes} alt="Seen on logo 2"></img>
                <img src={techcrunch} alt="Seen on logo 3"></img>
                <img src={bi} alt="Seen on logo 4"></img>

            </div>
        </header>
    )
}
